import clsx from "clsx";

import { Icon, type Icons } from "@web-app/components";

export default function TabTitle({
  description,
  icon,
  title,
}: {
  description?: string;
  icon: keyof typeof Icons;
  title: string;
}) {
  return (
    <div>
      <div className="flex items-center gap-2 px-6">
        <Icon name={icon} className="mr-2 h-6 text-gray-700" />
        <div>
          <h1 className={clsx("font-semibold text-xl text-gray-700")}>
            {title}
          </h1>
          <p className="text-sm text-gray-400">{description}</p>
        </div>
      </div>
      <hr className="w-full my-3 mb-5 border-gray-200" />
    </div>
  );
}
